"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbCCSessionStorage = void 0;
/* eslint-disable no-console */
/* eslint-disable complexity */
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const framework_1 = require("../../../../framework");
class MbCCSessionStorage extends framework_1.SessionStorage {
    constructor(store) {
        super(store);
    }
    getStoredData() {
        const username = this.store.getItem('documentNumber');
        const expiresIn = this.store.getItem('expiresIn');
        const savedSessionExpiresAt = this.store.getItem('sessionExpiresAt');
        const sessionExpiresAt = (savedSessionExpiresAt === null || savedSessionExpiresAt === void 0 ? void 0 : savedSessionExpiresAt.trim()) ? new Date(savedSessionExpiresAt) : null;
        const accessToken = this.store.getItem('accessToken');
        const refreshToken = this.store.getItem('refreshToken');
        const agentToken = this.store.getItem('agentToken');
        const agentRefreshToken = this.store.getItem('agentRefreshToken');
        const entrypoint = this.store.getItem('entrypoint');
        const savedTimeOutStamp = this.store.getItem('timeOutStamp');
        const timeOutStamp = savedTimeOutStamp ? Number(savedTimeOutStamp) : 0;
        if (agentToken) {
            return {
                username,
                expiresIn,
                sessionExpiresAt,
                accessToken,
                agentRefreshToken,
                refreshToken,
                timeOutStamp,
                agentToken,
                entrypoint,
            };
        }
        web_ui_framework_1.Log.warn('[MbCCSessionStorage] can not get stored data. Pending fields storaged');
        return null;
    }
    setStoreNewData(newData) {
        var _a, _b, _c;
        if (newData) {
            const { agentToken } = newData;
            if (agentToken) {
                this.store.setItem('documentNumber', newData.username || '');
                this.store.setItem('expiresIn', newData.expiresIn || 0);
                this.store.setItem('sessionExpiresAt', ((_b = (_a = newData.sessionExpiresAt) === null || _a === void 0 ? void 0 : _a.toISOString) === null || _b === void 0 ? void 0 : _b.call(_a)) || '');
                this.store.setItem('accessToken', newData.accessToken);
                this.store.setItem('refreshToken', newData.refreshToken);
                this.store.setItem('agentToken', newData.agentToken);
                this.store.setItem('agentRefreshToken', newData.agentRefreshToken || '');
                this.store.setItem('timeOutStamp', ((_c = newData.timeOutStamp) === null || _c === void 0 ? void 0 : _c.toString()) || '');
                this.store.setItem('entrypoint', newData.entrypoint);
            }
            else {
                web_ui_framework_1.Log.warn('[MbCCSessionStorage] can not set new data. Pending fields in data');
            }
        }
    }
    removeStoredSavedData() {
        this.store.removeItem('documentNumber');
        this.store.removeItem('expiresIn');
        this.store.removeItem('sessionExpiresAt');
        this.store.removeItem('accessToken');
        this.store.removeItem('refreshToken');
        this.store.removeItem('agentToken');
        this.store.removeItem('agentRefreshToken');
        this.store.removeItem('timeOutStamp');
        this.store.removeItem('entrypoint');
    }
}
exports.MbCCSessionStorage = MbCCSessionStorage;
//# sourceMappingURL=index.js.map